import React from "react";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import jwtDecode from "jwt-decode";
import ReactHtmlParser from "react-html-parser";
import CustomButton from "../../../../../components/inputs/button";
import "./dialog.css";

export function Dialog(props) {
  let lang = props.state.language;
  const handleSubmit = () => {
    // props.history.push();
    props.handleClose();
  };

  const handleClose = () => {
    sessionStorage.removeItem("active_path");
    props.handleClose();
  };
  //console.log(props.data);
  let userType = props.state.payload ? jwtDecode(props.state.payload) : {};
  //console.log(userType);
  let activeUserType =
    userType?.user?.user_type ||
    userType?.data?.user_type ||
    userType?.user_type ||
    (userType?.actor === "company_user" ? 4 : null);
  let activeUserStatus =
    userType?.user?.status ||
    userType?.status ||
    (userType?.actor === "company_user" ? 2 : null);
  return (
    <React.Fragment>
      <CSSTransition
        in={props.open}
        timeout={1000}
        classNames="my-node"
        unmountOnExit
      >
        <div className="overlay">
          <div className="big-menu-dias">
            <div className="row">
              <div className="flexDisplay">
                <div className="diaTitleCon text-center">
                  <div className="dia-menu-title">
                    {lang === "ma" ? props.data.title_ma : props.data.title_en}
                  </div>
                </div>
                <div className="dia-menu-close" onClick={(e) => handleClose(e)}>
                  <div className="diaCloseCon">
                    <div className="diaClose">&#10005;</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <hr />
            </div>
            <div className="dia-body">
              <p className="dialog-para">
                {props?.data?.specialPermissions &&
                  props?.data?.specialPermissions?.length > 0 ? (
                  <>
                    {props?.data?.specialPermissions?.some(
                      (s) => s == activeUserType
                    ) ? (
                      <>
                        {lang === "ma"
                          ? props.data.desc_ma
                          : props.data.desc_en}
                        {lang === "ma"
                          ? props.data.desc_ma
                            ? ReactHtmlParser(props.data.desc_ma)
                            : ""
                          : props.data.desc_en
                            ? ReactHtmlParser(props.data.desc_en)
                            : ""}
                      </>
                    ) : (
                      <>
                        {lang === "ma"
                          ? props.data.error_ma || props.data.error_en
                          : props.data.error_en}
                        {/* {props.data.specialPermissions.includes(8) ? (
                          <>
                            {lang === "ma"
                              ? "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. അക്കാദമിക് സ്ഥാപനങ്ങൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്."
                              : "You don't have permission to access this section. Only Academic Institutions have access to this section. "}
                          </>
                        ) : (
                          <>
                            {lang === "ma"
                              ? "ഈ വിഭാഗം ആക്സസ് ചെയ്യാൻ നിങ്ങൾക്ക് അനുമതിയില്ല. കെ.എസ്.എ.പി.എസ്, കേരള കമ്പനികൾക്ക് മാത്രമാണ് ഈ വിഭാഗത്തിലേക്ക് പ്രവേശനമുള്ളത്."
                              : "You don't have permission to access this section. Only kSapce and Kerala companies have access to this section. "}
                          </>
                        )} */}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {lang === "ma" ? (
                      props.data.label_en === "Job Seekers" ? (
                        <div className="text-start">
                          <p>
                            ദയവായി കെ-സ്പേസിലെ ജോബ് സീക്കർ രജിസ്റ്ററിൽ
                            അംഗമാകുന്നതിനായി നിങ്ങളുടെ അപേക്ഷ രജിസ്റ്റർ ചെയ്യുക.
                            ജോബ് സീക്കർ രജിസ്ട്രേഷൻ കെ-സ്പേസിലേക്ക് നേരിട്ടുള്ള
                            നിയമനത്തിനായി അല്ല, മറിച്ച് ഞങ്ങളുടെ അനുബന്ധ
                            കമ്പനികളിലൂടെ തൊഴിൽ അവസരങ്ങൾക്കായി ആണ്.ഇപ്പോൾ
                            കേരളത്തിൽ പ്രവർത്തിക്കുന്ന 50-ലധികം എയർസ്പേസ്,
                            പ്രതിരോധം, വ്യോമയാന മേഖലകളിലെ കമ്പനികൾ ഞങ്ങളുമായി
                            അനുബന്ധിതരാണ്. ഈ കമ്പനികളുടെ പട്ടിക ഞങ്ങളുടെ
                            വെബ്സൈറ്റിൽ ലഭ്യമാണ്.
                          </p>
                          <p>
                            രജിസ്ട്രേഷൻ പ്രക്രിയ ആരംഭിക്കുന്നതിന് മുമ്പ്, ദയവായി
                            താഴെപ്പറയുന്ന രേഖകൾ അപ്‌ലോഡ് ചെയ്യുന്നതിനായി
                            തയ്യാറാക്കിയിട്ടുണ്ടെന്ന് ഉറപ്പാക്കുക:
                          </p>
                          <ul>
                            <li>നിങ്ങളുടെ ഫോട്ടോഗ്രാഫ്</li>
                            <li>കരിക്കുലം വീറ്റേ (CV)</li>
                            <li>നിങ്ങളുടെ സ്വദേശ വിലാസമുള്ള തിരിച്ചറിയൽ രേഖ</li>
                            <li>വിദ്യാഭ്യാസ സർട്ടിഫിക്കറ്റുകൾ</li>
                            <li>
                              എക്സ്പീരിയൻസ് സർട്ടിഫിക്കറ്റ് (ആവശ്യമെങ്കിൽ)
                            </li>
                          </ul>
                        </div>
                      ) : props.data.desc_ma ? (
                        ReactHtmlParser(props.data.desc_ma)
                      ) : (
                        ""
                      )
                    ) : props.data.label_en === "Job Seekers" ? (
                      <div className="text-start">
                        <p>
                          Please register your request to be part of the Job
                          Seeker registry in KSPACE. Please note that the
                          Jobseeker registration is not for any direct
                          recruitment to KSPACE, but for employment
                          opportunities through our affiliated companies.
                          Currently, over 50 companies operating within Kerala
                          in the aerospace, defence, and aviation domains are
                          affiliated with us. The list of the companies is
                          available on our website.
                        </p>
                        <p>
                          Before you begin the registration process, please take
                          a moment to ensure you have the following documents
                          prepared for upload:
                        </p>
                        <ul>
                          <li>Your photograph</li>
                          <li>Curriculum vitae</li>
                          <li>Identity proof with your native address</li>
                          <li>Educational certificates</li>
                          <li>Experience letter (if applicable)</li>
                        </ul>
                      </div>
                    ) : (
                      props.data.desc_en ? ReactHtmlParser(props.data.desc_en) : ""
                    )}
                  </>
                )}
              </p>
              {/* <>{lang === "ma" ? props.data.desc_ma : props.data.desc_en}</> */}
            </div>
            {/* {(props.state.isUserAuthenticated || props.data.temp) && ( */}
            {!props?.data?.hideContinue && (
              <div className="icon-to-center">
                {props?.data?.specialPermissions &&
                  props?.data?.specialPermissions?.length > 0 ? (
                  <>
                    {props?.data?.specialPermissions?.some(
                      (s) => s == activeUserType
                    ) ? (
                      <Link to={props.data.path ?? "/"}>
                        <CustomButton
                          label="Continue"
                          onClick={(e) => handleSubmit(e)}
                        />
                      </Link>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <Link to={props.data.path ?? "/"}>
                    {/* {//console.log(props.data.path)} */}
                    <CustomButton
                      label="Continue"
                      onClick={(e) => handleSubmit(e)}
                    />
                  </Link>
                )}
              </div>
            )}
            {/* // )} */}
            {/* )} */}
          </div>
        </div>
      </CSSTransition>
    </React.Fragment>
  );
}

export default Dialog;
